import type { InputProps } from "@mui/joy";
import DarkInput from "./DarkInput";
import { colorTokens } from "../../styles/globalStyles";

interface DarkDatePickerProps extends Omit<InputProps, "type" | "onChange" | "ref"> {
  value: string;
  onChange: (value: string) => void;
  min?: string;
  max?: string;
}

export default function DarkDatePicker({
  value,
  onChange,
  min,
  max,
  sx,
  ...props
}: DarkDatePickerProps) {
  return (
    <DarkInput
      type="date"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      slotProps={{ input: { min, max, style: { colorScheme: "dark" } } }}
      sx={{
        fontSize: { xs: "0.8rem", sm: "0.875rem" },
        minHeight: { xs: 32, sm: 36 },
        "& input": { color: colorTokens.text.primary },
        ...sx,
      }}
      {...props}
    />
  );
}
